<template>
  <div class="content-wrapper d-lg-block" :class="{'d-none': isMobileMenuOpen}">
    <mobile-top @close-mobile-menu="close_mobile_menu"></mobile-top>

    <div class="updates-header">
      <b-row>
        <b-col cols="9" lg="10" xl="9">
          <h3>{{ intraday_updates_label }}<!--<span>{{ $t('components.intraday_updates.for_my_favorites') }}</span>--></h3>
          <base-checkbox v-model="toggle_show_charts_updates">
            {{ $t('components.intraday_updates.charts_updates') }}
          </base-checkbox>
        </b-col>
        <!--<b-col>
          <h4 class="d-none d-xl-block" @click="toggle_intraday_updates_filter()">
            <img src="../../assets/filter.svg">{{ $t('components.intraday_updates.filter') }}
          </h4>
          <h4 class="d-none d-lg-block d-xl-none" @click="toggle_intraday_updates_filter()">
            <img src="../../assets/filter.svg">
          </h4>
          <h4 class="d-block d-lg-none">
            {{ $t('components.intraday_updates.filter') }}
            <span>{{ $t('components.intraday_updates.date') }}</span>
            <div class="d-inline-block dropdown-icon-wrapper">
              <i class="fas fa-chevron-down"></i>
            </div>
          </h4>
        </b-col>-->
      </b-row>
    </div>

    <!--<div class="updates-filter" :class="{'d-none': isFilterClosed}">
      <b-row>
        <b-col cols="9">
          <h3>Filter Intraday Updates</h3>
        </b-col>
        <b-col class="text-right">
          <span @click="toggle_intraday_updates_filter()"><i class="fas fa-times"></i></span>
        </b-col>
        <b-col cols="12">
          <h4>Show updates for</h4>
          <form @submit.prevent="save_changes()">
            <b-row>
              <b-col v-for="filter_option in filter_options"
                    v-bind:key="filter_option.id"
              >
                <base-checkbox>
                  {{ filter_option.name }}
                </base-checkbox>
              </b-col>
            </b-row>
            <div class="text-center">
              <base-button
                class="btn-lg"
                type="submit"
              >
                {{ $t('components.intraday_updates.apply_filter') }}
              </base-button>
            </div>
          </form>
        </b-col>
      </b-row>
    </div>-->

    <div class="updates">
      <ul>
        <li class="search">
          <input type="text" :placeholder="$t('components.intraday_updates.search_placeholder')" v-model="search"/>
        </li>

        <li class="updates-loading" v-if="updates_loading">
          <img :src="loading_gif" alt="Loading" class="updates-loading-gif">
        </li>

        <li class="update"
            v-else
            v-for="(update, index) in updates_bar"
            v-bind:key="index"
            v-bind:class="{
              'trading-notes-and-instruments': update.type == 'instrument' || update.type == 'trading_note',
              'instrument': update.type == 'instrument',
              'instrument-visible': update.type == 'instrument' && show_charts_updates
            }"
        >
          <div :class="[
                update.type == 'intraday_update' && update.charts.length > constants.max_intraday_number_of_graphs || update.type == 'intraday_update' && update.content.length > constants.max_intraday_text_length ? 'overlay-content' : '',
                {'active': isHidden[index]}
               ]"
               v-if="update.type == 'intraday_update'"
          >
            <b-row class="top-part">
              <b-col cols="8">

                <h5 v-html="update.title" v-if="update.title"></h5>

                <h5 v-if="update.linked_instruments.length > 0 && (update.title == null || update.title == '')">

                  <span v-for="(linked_instrument, index) in update.linked_instruments"
                        v-bind:key="linked_instrument.id"
                        v-html="comma_to_list(linked_instrument.name, update.linked_instruments.length - 1, index)"
                  ></span>
                </h5>

                <img v-for="market in update.markets"
                     v-bind:key="market.id"
                     class="market-icon"
                     :src="require(`@/assets/icon-${market.slug}.svg`)"
                     alt="Market"
                     width="19"
                >

              </b-col>
              <b-col>
                <small>
                  <time-ago :refresh="30" :long="true" :datetime="update.sortable_date" />
                </small>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="8" sm="9" lg="12" xl="9">
                <p v-html="update.content"></p>
              </b-col>
              <b-col>
                <div class="intraday-image"
                    v-for="chart in update.charts"
                    v-bind:key="chart.id"
                >
                  <img v-if="chart.chart_url == 'demo'" :src="demo_chart()" alt="Chart">
                  <img v-if="chart.chart_url != 'demo'" v-bind:src="chart.chart_url" alt="Chart">

                  <div class="image-overlay"
                       @click="show_intraday_single(update.id, chart.id)"
                  >
                    <h6>{{ chart.title }}</h6>
                    <small>
                      <time-ago :refresh="60" :long="false" :datetime="chart.created_at" />
                    </small>
                    <img src="@/assets/graph-zoom.svg" class="graph-zoom-icon">
                  </div>

                </div>
              </b-col>
            </b-row>

            <div v-if="update.charts.length > constants.max_intraday_number_of_graphs || update.content.length > constants.max_intraday_text_length" class="text-center">
              <div class="overlay-buttons">
                <a @click="intraday_update_list_toggle(index)">
                  {{!isHidden[index] ? $t('components.intraday_updates.show_more') : $t('components.intraday_updates.show_less')}}
                </a>
              </div>
            </div>

          </div>

          <div v-else-if="update.type == 'trading_note'">
            <b-row>
              <b-col cols="8" lg="7" xl="8">
                <p>
                  {{ $t('components.intraday_updates.trading_notes_updates_for') }}
                  <span v-for="instrument in update.instruments"
                        v-bind:key="instrument.id"
                  >
                    <span v-if="instrument.markets.includes(market)">
                      <a
                        @click="scroll_to(`#${instrument.slug}`), close_mobile_menu(true)"
                      >
                        {{instrument.name}}
                      </a>
                    </span>
                  </span>
                </p>
              </b-col>
              <b-col>
                <time-ago :refresh="30" :long="true" :datetime=" update.sortable_date" />
              </b-col>
            </b-row>
          </div>
          <div v-else-if="update.type == 'instrument' && show_charts_updates">
            <b-row>
              <b-col cols="8" lg="7" xl="8">
                <p>
                  {{ $t('components.intraday_updates.chart_update_for') }}
                  <span>
                    <a @click="scroll_to(`#${update.slug}`), close_mobile_menu(true)"
                    >
                      {{update.name}}
                    </a>
                  </span>
                </p>
              </b-col>
              <b-col>
                <time-ago :refresh="30" :long="true" :datetime=" update.sortable_date" />
              </b-col>
            </b-row>
          </div>
        </li>
      </ul>
    </div>
    <div v-for="intraday_update in intraday_updates"
         v-bind:key="intraday_update.id">
      <intraday-single
        :ref="'intraday_single_' + intraday_update.id"
        :intraday_update_id="intraday_update.id"
        :intraday_update_chart_active_id="intraday_update_chart_active_id"
      />
    </div>
  </div>
</template>

<script>
import BaseCheckbox from '../../components/BaseCheckbox.vue'
// import BaseCheckbox from '../../components/BaseCheckbox.vue'
import IntradaySingle from './Single.vue'
import { mapState, mapActions } from 'vuex'
import MobileTop from '../market/MobileTop.vue'

export default {
  props: ['isMobileMenuOpen'],
  data () {
    return {
      isFilterClosed: true,
      isInstradaySingleClose: true,
      intraday_update_chart_active_id: '',
      isHidden: [],
      constants: {
        max_intraday_number_of_graphs: 2,
        max_intraday_text_length: 150
      },
      search: '',
      filter_options: [
        {
          id: 1,
          name: 'Primary Markets'
        },
        {
          id: 2,
          name: 'Other Updates/Markets'
        },
        {
          id: 3,
          name: 'Trading notes'
        }
      ],
      market: null
    }
  },
  components: {
    MobileTop,
    BaseCheckbox,
    // BaseButton,
    IntradaySingle
  },
  mounted () {
    this.market = this.$route.matched[0].meta.market

    this.$store.dispatch('intraday_updates/loadIntradayUpdates')
    this.$store.dispatch('trading_notes/load_trading_notes')
    this.$store.dispatch('updates/load_updates')
    this.$store.dispatch('updates/show_charts_updates')
    this.$store.dispatch('market/loadMarkets')

    this.$cable.subscribe({
      channel: 'IntradayUpdateChannel'
    })

    this.$cable.subscribe({
      channel: 'UpdateChannel'
    })
  },
  computed: {
    ...mapState({
      intraday_updates: state => state.intraday_updates.intraday_updates,
      trading_notes: state => state.trading_notes.trading_notes,
      updates: state => state.updates.updates,
      updates_loading: state => state.updates.loading,
      show_charts_updates: state => state.updates.show_charts_updates,
      current_user: state => state.profile.account.current_user,
      popup_visibility: state => state.subscribe_popup.popup_visibility,
      markets: state => state.market.markets,
      user_theme: state => state.user_theme.user_theme
    }),
    intraday_updates_label () {
      const market = this.markets.find(market => market.slug === this.market)
      return market ? market.intraday_updates_tab_label : ''
    },
    loading_gif () {
      return this.user_theme ? '/img/logo-wave-dark-anim.gif' : '/img/logo-wave-anim.gif'
    },
    updates_bar () {
      const filtered_updates = this.updates.filter(
        update => update.markets?.some(
          market => market === this.market
        ) || update.instruments?.some(
          instrument => instrument.markets.includes(this.market)
        ) || update.markets?.some(
          market => market.slug === this.market
        )
      )

      filtered_updates.sort((a, b) => new Date(b.sortable_date) - new Date(a.sortable_date))

      if (this.search === '') {
        return filtered_updates
      }

      return filtered_updates.filter(
        update => update.linked_instruments?.some(
          linked_instrument => linked_instrument.name.toLowerCase().includes(this.search.toLowerCase())
        ) ||
          update.content?.toLowerCase().search(this.search.toLowerCase()) > -1 ||
          update.title?.toLowerCase().search(this.search.toLowerCase()) > -1
      )
    },
    toggle_show_charts_updates: {
      get () {
        return this.show_charts_updates
      },
      set (show_charts_updates) {
        this.$store.dispatch('updates/update_show_charts_updates', show_charts_updates)
      }
    }
  },
  methods: {
    ...mapActions({
      open_popup: 'subscribe_popup/open_popup'
    }),
    close_mobile_menu (is_scroll) {
      this.$emit('close-mobile-menu', is_scroll)
    },
    toggle_intraday_updates_filter () {
      this.isFilterClosed = !this.isFilterClosed
    },
    save_changes () {
      this.$notify({
        text: this.$t('components.intraday_updates.successfully_updated')
      })
    },
    intraday_update_list_toggle (index) {
      if (this.check_for_subscription()) {
        this.$set(this.isHidden, index, !this.isHidden[index])
      } else {
        this.open_subscribe_popup()
      }
    },
    comma_to_list (text, list_length, index) {
      if (index !== list_length) {
        return text + ', '
      }

      return text
    },
    show_intraday_single (intraday_update_id, chart_id) {
      if (this.check_for_subscription()) {
        this.intraday_update_chart_active_id = chart_id

        const modal_id = 'intraday_single_' + intraday_update_id
        this.$refs[modal_id][0].show(intraday_update_id)
      } else {
        this.open_subscribe_popup()
      }
    },
    scroll_to (element) {
      this.$scrollTo(element, 500, { container: '.content', offset: -60 })
    },
    check_for_subscription () {
      if (this.current_user.open_door && this.current_user.open_door_accessed) {
        return true
      }

      const market_subscription = this.current_user.subscriptions.filter(
        s => s.markets.some(
          m => m.slug === this.market
        )
      ).length

      return !(this.current_user.subscriptions.length === 0 || market_subscription === 0)
    },
    open_subscribe_popup () {
      this.open_popup()
    },
    demo_chart () {
      const rand_num = Math.floor(Math.random() * 10) + 1
      const demo_image = `/img/demo_chart-${rand_num}.png`
      return demo_image
    }
  },
  channels: {
    IntradayUpdateChannel: {
      received (data) {
        this.$store.dispatch('intraday_updates/load_intraday_update_from_cable', { intraday_update: JSON.parse(data) })
      }
    },
    UpdateChannel: {
      received (data) {
        this.$store.dispatch('updates/load_updates_from_cable', { update: JSON.parse(data) })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.updates-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 240px);
  background-color: var(--pale-grey-two-charcoal-grey-two);
  backdrop-filter: blur(6px);
}

.updates-loading-gif {
  width: 50px;
  height: auto;
}
</style>
